import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaicabservice() {



  const cardData = {
    keyword: " Mumbai Cab Service  ",


"headingDescription": "Royal Route Cab offers reliable Mumbai cab service, providing safe, comfortable, and affordable transportation for local travel, airport transfers, corporate rides, daily commuting, and outstation journeys. Whether you need a quick city ride, full-day rental, or long-distance travel, our professional drivers and well-maintained vehicles ensure a smooth and stress-free experience across Mumbai and nearby regions. We focus on punctual pickups, transparent pricing, clean vehicles, and easy booking with no hidden charges. Our fleet includes economy sedans, premium sedans, SUVs, Innova, Ertiga, Innova Crysta, luxury cars, and Tempo Travellers suitable for all travel needs. With 24/7 availability and quick customer support, Royal Route Cab is your trusted choice for Mumbai cab service.",

"topPlaces": [
  {
    "title": "Mumbai Cab Booking Service",
    "description": "Mumbai cab booking service provides fast and reliable transportation for all types of travel needs including airport transfers, local rides, and outstation journeys. It ensures comfort, safety, and easy booking options for passengers."
  },
  {
    "title": "City Travel Cab Service Mumbai",
    "description": "City travel cab service in Mumbai is ideal for daily commuting, shopping trips, office travel, and personal errands. It offers a convenient and affordable way to move around the city."
  },
  {
    "title": "Private Cab Service Mumbai",
    "description": "Private cab service in Mumbai offers personalized travel solutions with dedicated vehicles for individuals, families, and business travelers who prefer privacy and comfort."
  },
  {
    "title": "Mumbai Taxi and Cab Service",
    "description": "Mumbai taxi and cab service provides quick and easy transportation across the city with professional drivers, making it suitable for both short and long-distance travel."
  },
  {
    "title": "Intercity Cab Service from Mumbai",
    "description": "Intercity cab service from Mumbai is commonly used for travel to nearby cities such as Pune, Nashik, Lonavala, and Shirdi, offering comfortable long-distance rides."
  },
  {
    "title": "Executive Cab Service Mumbai",
    "description": "Executive cab service in Mumbai is designed for business professionals who need premium and punctual transportation for meetings, corporate events, and airport transfers."
  },
  {
    "title": "Budget Cab Service Mumbai",
    "description": "Budget cab service in Mumbai provides affordable travel options without compromising safety and comfort, making it ideal for daily commuters and regular travelers."
  },
  {
    "title": "Premium Cab Service Mumbai",
    "description": "Premium cab service in Mumbai offers high-end vehicles and professional drivers for a superior travel experience suitable for special occasions and VIP travel."
  },
  {
    "title": "Hourly Cab Hire Mumbai",
    "description": "Hourly cab hire in Mumbai allows customers to book a cab for a fixed time period, making it useful for meetings, errands, and multiple-stop travel within the city."
  },
  {
    "title": "24 Hour Cab Service Mumbai",
    "description": "24-hour cab service in Mumbai ensures round-the-clock availability for passengers, providing reliable transportation at any time of the day or night."
  }
],






services: [
  {
    name: "Mumbai Cab Service",
    description: "Mumbai cab service offers reliable and comfortable transportation for local travel, airport transfers, and outstation trips. With well-maintained vehicles and professional drivers, this service ensures smooth and safe journeys. Ideal for daily commuting and business travel. It guarantees a hassle-free experience."
  },
  {
    name: "Mumbai to Shirdi Cab",
    description: "Mumbai to Shirdi cab service provides convenient travel for devotees visiting Sai Baba Temple. This service ensures safe and comfortable long-distance journeys with experienced drivers. Ideal for family and spiritual trips. It guarantees a peaceful travel experience."
  },
  {
    name: "Cab from Pune to Mumbai",
    description: "Cab from Pune to Mumbai offers reliable intercity travel with flexible pickup and drop options. This service is ideal for business travelers and daily commuters. Comfortable vehicles ensure a smooth highway journey. It ensures timely and efficient travel."
  },
  {
    name: "Cab Booking Mumbai",
    description: "Cab booking Mumbai allows customers to reserve rides easily with flexible options. Travelers can select vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai to Shirdi Taxi",
    description: "Mumbai to Shirdi taxi offers private and comfortable travel for pilgrimage journeys. Door-to-door pickup and flexible schedules enhance convenience. Suitable for families and groups. It ensures a smooth and reliable journey."
  },
  {
    name: "Cheapest Cab Service in Mumbai",
    description: "Cheapest cab service in Mumbai provides budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Cab Service in Mumbai",
    description: "Best cab service in Mumbai ensures premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. It guarantees a reliable and comfortable journey."
  },
  {
    name: "Mumbai to Vadodara Taxi",
    description: "Mumbai to Vadodara taxi provides reliable long-distance travel between cities. This service is ideal for business and personal trips. Comfortable vehicles and experienced drivers ensure a smooth journey. It guarantees a hassle-free experience."
  },
  {
    name: "Airport Taxi Mumbai",
    description: "Airport taxi Mumbai offers convenient pickup and drop services to all airport terminals. This service ensures timely travel for flights. Professional drivers and clean vehicles enhance comfort. It guarantees a stress-free airport transfer."
  },
  {
    name: "Outstation Cabs Mumbai",
    description: "Outstation cabs Mumbai provide reliable travel to nearby cities and long-distance destinations. This service includes one way and round trip options. Vehicles are maintained for highway travel. It ensures a safe and comfortable journey."
  },
  {
    name: "Mumbai to Vadodara Cab",
    description: "Mumbai to Vadodara cab offers flexible and comfortable intercity travel with multiple vehicle options. Ideal for family trips and business travel. Professional drivers ensure safety. It guarantees a smooth journey."
  },
  {
    name: "Mumbai to Goa Car Rentals",
    description: "Mumbai to Goa car rentals provide flexible travel options for one of the most popular road trips. This service is ideal for families, friends, and tourists. Comfortable vehicles and scenic routes enhance the journey. It ensures a memorable travel experience."
  }
],

tableData: [
  ["Mumbai Cab Service", "Mumbai to Shirdi Cab"],
  ["Cab from Pune to Mumbai", "Cab Booking Mumbai"],
  ["Mumbai to Shirdi Taxi", "Cheapest Cab Service in Mumbai"],
  ["Best Cab Service in Mumbai", "Mumbai to Vadodara Taxi"],
  ["Airport Taxi Mumbai", "Outstation Cabs Mumbai"],
  ["Mumbai to Vadodara Cab", "Mumbai to Goa Car Rentals"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai Cab Service",
    WhyChoosedescription: "Royal Route Cabs offers dependable cab service in Mumbai for local travel, airport transfers, corporate use, and outstation trips."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained, courteous, and experienced in Mumbai city routes, ensuring safe and timely travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "We provide clear and upfront pricing with no hidden costs, ensuring complete fare transparency."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai cab service operates 24/7, allowing you to book rides anytime for daily travel or urgent needs."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned for a comfortable ride experience."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "We provide cab services for local Mumbai travel, airport pickup-drop, and outstation journeys."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses."
  },
  {
    WhyChooseheading: "Trusted Cab Service Provider",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable and punctual cab service in Mumbai."
  }
]

};

const faqData = [
  { question: "Do you provide cab service in Mumbai?", answer: "Yes, Royal Route Cabs offers reliable cab services across Mumbai for local and outstation travel." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai cab service operates 24/7." },
  { question: "Do you provide airport cab service?", answer: "Yes, we offer Mumbai airport pickup and drop services." },
  { question: "Which areas do you cover in Mumbai?", answer: "We cover all areas including South Mumbai, Andheri, Borivali, Navi Mumbai, and Thane." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book a cab for outstation travel?", answer: "Yes, we provide outstation cab services from Mumbai to various destinations." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for peak hours and long-distance travel." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Jadhav",
    feedback: "Mumbai cab service from Royal Route Cabs was very reliable and punctual. The ride was smooth and the driver was professional throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Mehta",
    feedback: "Excellent cab service in Mumbai. The booking was quick, the vehicle was clean, and the overall travel experience was comfortable and stress-free.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Cab Service",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-cab-service.jpg", // replace if needed
  "description": "Book Mumbai cab service with Royal Route Cabs for local rides, airport transfers, and outstation travel. Available for Shirdi, Pune, Vadodara, Goa, and across India. Safe, affordable, and 24x7 reliable taxi service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "499", // base starting fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-cab-service"
  }
};







  return (
    <div>

<Helmet>
  <title>Mumbai Cab Service | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai cab service with Royal Route Cabs. Local, airport & outstation taxis available for Shirdi, Pune, Goa, Vadodara & more. Cheapest and best cab service in Mumbai."
  />

  <meta
    name="keywords"
    content="mumbai cab service, mumbai to shirdi cab, cab from pune to mumbai, cab booking mumbai, mumbai to shirdi taxi, cheapest cab service in mumbai, best cab service in mumbai, mumbai to vadodara taxi, airport taxi mumbai, outstation cabs mumbai, mumbai to vadodara cab, mumbai to goa car rentals"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/101.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaicabservice;